<template>
  <div>
    <loading v-if="isDownloading" />
    <div class="row mb-10 mt-10">
      <div class="col-md-6">
        <button class="btn btn-primary" @click="onFilterClick()">{{ filterBtnText }}</button>
      </div>
      <div class="col-md-6 text-right">
        <button class="btn btn-link" @click="onViewClick()" :disabled="currentView === 'Grid'">
          <view-grid />
        </button>
        <button class="btn btn-link"  @click="onViewClick()" :disabled="currentView === 'List'">
          <view-list />
        </button>
        <button class="btn btn-link" @click="onDownloadClick()">
          <download />
        </button>
      </div>
    </div>
  
    <search-form v-if="showForm" :sex_types="gender_options" :status_types="status_types" @searchSubmit="searchPresos"></search-form>

    <transition name="fade">
      <div class="text-center" v-if="loading">
        <refresh class="rotate" />
      </div>

      <div v-else>
        <div class="row mb-10" v-if="currentView === 'Grid'">
          <preso-block v-for="(preso, index) in presos" 
          :key="preso.id"
          :image_url="preso.image_url" 
          :nombres="preso.nombres" 
          :preso_slug="preso.slug" 
          :position="last+index+1"
          :style="currentView" />
        </div>
        
        <div class="row mb-10" v-else>
          <preso-table :presos="presos" :last="last"/>
        </div>

        <div class="row mb-10">
          <div class="col-md-6">
            <strong>Total de Resultados</strong>: {{ total }}
          </div>
          <div class="col-md-6 text-right">
            <button :disabled="page === 1" class="btn btn-link" @click="onPageChange(-1)"><chevron-left/></button>
            <span class="d-inline-block">Página </span>
            <select name="current_page" id="current_page" v-model="page">
              <option v-for="p in pages" :key="p" :value="p">{{p}}</option>
            </select>
            <span class="d-inline-block"> de {{ pages }}</span>
            <button :disabled="page === pages" class="btn btn-link" @click="onPageChange(1)"><chevron-right/></button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { api_url, web_url } from './main.js';
import SearchForm from './components/SearchForm.vue';
import ViewGrid from './components/icons/ViewGrid.vue';
import ViewList from './components/icons/ViewList.vue';
import Refresh from './components/icons/Refresh.vue';
import ChevronLeft from './components/icons/ChevronLeft.vue';
import ChevronRight from './components/icons/ChevronRight.vue';
import Download from './components/icons/Download.vue';
import PresoBlock from './components/PresoBlock.vue';
import PresoTable from './components/PresoTable.vue';
import Loading from './components/Loading.vue';

export default {
  name: "App",
  components: {
    SearchForm,
    ViewGrid,
    ViewList,
    Refresh,
    ChevronLeft, 
    ChevronRight,
    PresoBlock,
    PresoTable,
    Download,
    Loading
  },
  data() {
    return {
      showForm: false,
      filterBtnText: 'Filtrar',
      currentView: 'Grid',
      presos: [],
      page: 1,
      pages: 1,
      total: 0,
      last: 0,
      limit: 0,
      loading: true,
      web_url: web_url,
      search_data: {},
      isDownloading: false,
      gender_options: []
    }
  },
  setup() {
    const status_types = [
      {valor: "Excarcelado", id: 1},
      {valor: "Preso Politico", id: 2}
    ];

    return {
      status_types,
    }
  },
  beforeMount(){
    this.getPresosPoliticos();
    this.getGender();
  },
  watch: {
    page(newPage, oldPage) {
      if(newPage !== oldPage) {
        this.getPresosPoliticos();
      }
    }
  },
  methods: {
    onFilterClick(){
      this.showForm = !this.showForm;
      if(this.showForm) this.filterBtnText = "Cerrar";
      else this.filterBtnText = "Filtrar";
    },
    onViewClick() {
      this.currentView = (this.currentView === 'List') ? 'Grid' : 'List';
    },
    onPageChange(value) {
      let newpage = this.page + value;
      if(newpage !== this.page && newpage > 0 && newpage <= this.pages) {
        this.page = newpage;
      }      
    },
    async getGender() {
      let api_str = api_url+"/genero";
      const res = await fetch(api_str);
      const data = await res.json();
      this.gender_options = data;
    },
    async getPresosPoliticos() {
      this.loading = true;
      let api_str = api_url+"/presos-politicos?page="+this.page;
      
      if(this.search_data && Object.keys(this.search_data).length) {
        api_str += '&search_terms=' + this.search_data;
      }

      const res = await fetch(api_str);
      const data = await res.json();
      this.presos = data.presos;
      this.pages = data.pages;
      this.page = data.page;
      this.total = data.total;
      this.loading = false;
      this.limit = data.limit;
      this.last = (this.page - 1) * this.limit;
      
    },
    searchPresos(e) {
      this.search_data = (e) ? JSON.stringify(e) : '';
      this.getPresosPoliticos();
    },
    async onDownloadClick() {
      this.isDownloading = true;
      let api_str = api_url+"/descarga";
      
      if(this.search_data && Object.keys(this.search_data).length) {
        api_str += '&search_terms=' + this.search_data;
      }
      
      await fetch(api_str)
      .then(response => response.blob())
      .then(blob => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = "presos-politicos.csv";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();    
        a.remove();
        this.isDownloading = false;
      });
    }
  }
};
</script>


<style>
#app {
  width: 100%;
}
.mb-10 {
  margin-bottom: 10px;
}
.mt-10 {
  margin-top: 10px;
}
svg {
  height: 20px;
  width: 20px;
}
.btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  border-radius: 0px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.btn-link {
  font-weight: 400;
  color: #20113a;
  border-radius: 0;
}
.btn-link, .btn-link.active, .btn-link:active, .btn-link[disabled], fieldset[disabled] .btn-link, .btn.btn-link:disabled:hover {
  background-color: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-color:transparent; 
}
.btn.btn-link:disabled, .btn.btn-link:disabled:hover{
  color: gray;
}
.rotate {
  animation: rotateEl 2s infinite linear;
}
@keyframes rotateEl {
  from {
				transform: rotate(359deg);
		}
		to {
				transform: rotate(0deg);
		}
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

#current_page {
  display: inline-block;
  border: 0px;
  padding: 5px 10px;
  margin: 0px 5px;
  background: #f0eaf9;
  color: #20113a;
}
</style>
